import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { getFormattedValue } from "../../../../utils/previewValueFormatterUtils";
import { PreviewCardLayout } from "./PreviewCardLayout";

interface Member {
  email?: string;
  name?: string;
}

interface MemberCardProps {
  params: { members?: Array<Member> };
  url: string;
}

export const MEMBER_FIELDS = {
  name: {
    label: t("settings.invite_members.details_tab.member_details.name"),
    type: "string",
  },
  email: {
    label: t("settings.invite_members.details_tab.member_details.email"),
    type: "string",
  },
};

export const MemberCard = ({ params, url }: MemberCardProps) => {
  const members = params.members || [];

  return (
    <PreviewCardLayout
      title={t("help_widget.copilot.preview_cards.member_card_title")}
      url={url}
    >
      <div className="flex flex-col gap-3">
        {members.map((member, index) => {
          const key = member.email ?? member.name ?? String(index);

          return (
            <ul key={key} className="flex flex-col leading-5">
              {Object.entries(MEMBER_FIELDS).map(([key, keyProps]) => {
                const memberKey = key as keyof Member;
                const value = member[memberKey];

                if (!(memberKey in member) || value == null) {
                  return null;
                }

                return (
                  <li key={key} className="text-darkest !pb-0">
                    <Typography.BodySm color="text-darkest">
                      <strong>{keyProps.label}:</strong>{" "}
                      {getFormattedValue(value, keyProps.type)}
                    </Typography.BodySm>
                  </li>
                );
              })}
            </ul>
          );
        })}
      </div>
    </PreviewCardLayout>
  );
};
